module.exports = __webpack_public_path__ + "static/media/Stellar Max Single Headboard - 120 cm.0b5e6dfc.jpg";